import { ResponseData, Err } from 'types';

import { http } from '.';

export const deleteInvoicePayment = async (id: any) => {
  return await http.delete<Err, ResponseData<boolean>>(
    `/PaymentMethod/DeletePaymentReceiveds/${id}`
  );
};
export const generateInvoiceNumber = async () => {
  return await http.get<Err, ResponseData<any>>(`/GenerateInvoiceNumber`);
};
export const sendEmail = async (invoiceId: number) => {
  return await http.post<Err, ResponseData<any>>(
    `Invoices/EmailInvoiceToPartner/${invoiceId}`
  );
};
export const getInvoice = async (id: number) => {
  return await http.get<Err, ResponseData<any>>(`Invoices/${id}`);
};
export const getCost = async (id: number) => {
  return await http.get<Err, ResponseData<any>>(`Costs/${id}`);
};

export const getInvoiceDetails = async (id: number) => {
  return await http.get<Err, ResponseData<any>>(
    `Invoices/GetInvoiceDetails/${id}`
  );
};
export const getCostDetails = async (id: number) => {
  return await http.get<Err, ResponseData<any>>(`Costs/GetCostDetails/${id}`);
};
export const getInvoicePaymentDetails = async (
  id: number,
  pageSize: number,
  pageIndex: number
) => {
  return await http.get<Err, ResponseData<any>>(
    `PaymentMethod/GetReceivedPayments/${id}?PageIndex=${pageIndex}&PageSize=${pageSize}`
  );
};
export const getInvoiceLinesDetails = async (invoiceId) => {
  return await http.get<Err, ResponseData<any>>(
    `InvoiceLines/GetInvoiceLinesDetails?invoiceId=${invoiceId}`
  );
};
export const getCostLinesDetails = async (invoiceId) => {
  return await http.get<Err, ResponseData<any>>(
    `CostLines/GetCostLinesDetails?costId=${invoiceId}`
  );
};
export const getInvoiceLines = async (invoiceId) => {
  return await http.get<Err, ResponseData<any>>(
    `InvoiceLines?invoiceId=${invoiceId}`
  );
};
export const getCostLines = async (invoiceId) => {
  return await http.get<Err, ResponseData<any>>(
    `CostLines?costId=${invoiceId}`
  );
};

export const getInvoiceDownload = async (invoiceId: number) => {
  return await http.get(`IO/DownloadPdfByInvoiceId/IO/`, {
    params: { invoiceId },
    responseType: 'blob',
  });
};
export const getCostDownload = async (invoiceId: number) => {
  return await http.get(`IO/DownloadPdfByInvoiceId/IO/`, {
    params: { invoiceId },
    responseType: 'blob',
  });
};
export const makeAkt = async (invoiceId: number) => {
  return await http.get(`IO/MakeAkt/`, {
    params: { invoiceId },
    responseType: 'blob',
  });
};

export const createInvoice = async (payload) => {
  return await http.post<Err, ResponseData<number>>(`Invoices/Create`, payload);
};
export const createCost = async (payload) => {
  return await http.post<Err, ResponseData<number>>(`Costs`, payload);
};

export const updateInvoice = async (payload) => {
  return await http.put<Err, ResponseData<number>>(`Invoices/`, payload);
};

export const createElectronicInvoice = async (payload) => {
  return await http.put<Err, ResponseData<number>>(
    `Invoices/UpdateQaimeDetails`,
    payload
  );
};

export const updateCost = async (payload) => {
  return await http.put<Err, ResponseData<number>>(`Costs/`, payload);
};

export const getDrafts = async (pageSize: number, pageIndex: number) => {
  return await http.get<Err, ResponseData<any>>(
    `Invoices/GetDraftList?PageIndex=${pageIndex}&PageSize=${pageSize}`
  );
};
export const getExpensesList = async (pageSize: number, pageIndex: number) => {
  return await http.get<Err, ResponseData<any>>(
    `Costs/GetExpenses?PageIndex=${pageIndex}&PageSize=${pageSize}`
  );
};
export const getIncomesList = async (pageSize: number, pageIndex: number) => {
  return await http.get<Err, ResponseData<any>>(
    `Invoices/GetIncomes?PageIndex=${pageIndex}&PageSize=${pageSize}`
  );
};
export const getGetIncomesAndExpensesList = async (
  pageSize: number,
  pageIndex: number
) => {
  return await http.get<Err, ResponseData<any>>(
    `Invoices/GetIncomesAndExpenses?PageIndex=${pageIndex}&PageSize=${pageSize}`
  );
};

export const deleteDraftInvoice = async (id: number, invoiceNumber: string) => {
  return await http.delete<Err, ResponseData<any[]>>(`Invoices/${id}`, {
    data: { invoiceNumber },
  });
};

export const deleteDraftCost = async (id: number, description: string) => {
  return await http.delete<Err, ResponseData<any[]>>(`Costs/${id}`, {
    data: { description },
  });
};

export const createCostLine = async (invoiceLine) => {
  return await http.post<Err, ResponseData<any[]>>(`CostLines`, invoiceLine);
};

export const updateCostLine = async (invoiceLine) => {
  return await http.put<Err, ResponseData<any>>(`/CostLines`, invoiceLine);
};

export const deleteCostLine = async (
  costLineId: number,
  description: string
) => {
  return await http.delete<Err, ResponseData<number>>(
    `CostLines/${costLineId}`,
    {
      data: { description },
    }
  );
};
export const deleteInvoiceLine = async (
  invoiceLineId: number,
  description: string
) => {
  return await http.delete<Err, ResponseData<number>>(
    `InvoiceLines/${invoiceLineId}`,
    {
      data: { description },
    }
  );
};
export const finishInvoice = async (id: number) => {
  return await http.put<Err, ResponseData<any>>(`Invoices/Finish/${id}`);
};

export const createInvoiceLine = async (invoiceLine) => {
  return await http.post<Err, ResponseData<any[]>>(`InvoiceLines`, invoiceLine);
};

export const updateInvoiceLine = async (invoiceLine) => {
  return await http.put<Err, ResponseData<any>>(`/InvoiceLines`, invoiceLine);
};

export const finishCost = async (id: number) => {
  return await http.put<Err, ResponseData<any>>(`Costs/Finish/${id}`);
};

export const getIncomesAndExpenses = async (isInvoice: boolean) => {
  return await http.get<Err, ResponseData<any>>(
    `Invoices/GetIncomesAndExpenses?isInvoice=${isInvoice}`
  );
};
export const updateInvoiceDraft = async (payload) => {
  return await http.put<Err, ResponseData<any>>(
    `Invoices/UpdateForDraft`,
    payload
  );
};

export const updateCostDraft = async (payload) => {
  return await http.put<Err, ResponseData<any>>(
    `Costs/UpdateForDraft`,
    payload
  );
};

export const cancelInvoice = async (invoiceId: number) => {
  return await http.put<Err, ResponseData<any>>(
    `Invoices/CancelInvoice/${invoiceId}`
  );
};
export const cancelCost = async (invoiceId: number) => {
  return await http.put<Err, ResponseData<any>>(
    `Costs/CancelInvoice/${invoiceId}`
  );
};
export const getInvoiceForPrint = async (
  invoiceId: string,
  language: string
) => {
  return await http.get<Err, ResponseData<any>>(
    `Invoices/GetInvoiceForPrint?invoiceId=${invoiceId}&language=${language}`
  );
};

export const getRemainingDebt = async (invoiceId: string) => {
  return await http.get<Err, ResponseData<any>>(
    `PaymentMethod/GetRemainDebt/${invoiceId}`
  );
};

export const paymentReceive = async (body) => {
  return await http.post<Err, ResponseData<any>>(
    `PaymentMethod/PaymentReceived`,
    body
  );
};
